import React, { useEffect } from 'react';
import System from 'src/helper/system';
import ShowAlert from 'src/component/Global/ShowAlert';
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import Helper from 'src/helper/Helper';
import Order from "@system/config/order";
import QuoteInformation from '../QuoteCheckout/QuoteInformation';
import QuoteCheckoutShipping from '../QuoteCheckout/QuoteCheckoutShipping';
import QuoteCheckoutShippingMethod from '../QuoteCheckout/QuoteCheckoutShippingMethod';
import QuoteCheckoutPaymentMethod from '../QuoteCheckout/QuoteCheckoutPaymentMethod';
import QuoteCheckoutCartList from '../QuoteCheckout/QuoteCheckoutCartList';
import QuoteCheckoutTotal from '../QuoteCheckout/QuoteCheckoutTotal';

export function QuoteCheckout() {
    const { storageName: { SUCCESS_PAGE } } = System;

    const isFrom = sessionStorage.getItem(SUCCESS_PAGE)?.includes(SUCCESS_PAGE);

    useEffect(() => {
        if (isFrom) {
            window.location.href = Order.getOrderRouteURL();
        }

        Helper.feedBackButtonScript()
    }, []);

    return (
        <>
            {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
            <div className='checkout-process pt-3'>
                <div className='container'>
                    <div className='bs5 row'>
                        <div className='col-12'>
                            <div className='cart-alert'>
                                <ShowAlert doNotShow={['ExportCompliance']} />
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9'>
                            <div className='checkout-steps'>
                                <QuoteInformation />

                                <QuoteCheckoutShipping />

                                <QuoteCheckoutShippingMethod />

                                <QuoteCheckoutPaymentMethod />

                                <QuoteCheckoutCartList />
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3'>
                            <QuoteCheckoutTotal isFrom="checkout" />
                        </div>
                    </div>

                </div>

            </div>
        </>
    )

}